module.exports = __webpack_public_path__ + "static/media/valor1.e88a16bc.png";